import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faListUl } from '@fortawesome/pro-light-svg-icons';

export type ProLightListUlProps = IconComponentProps;

export const ProLightListUl = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightListUlProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faListUl}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faListUl}
    />
  );
};

ProLightListUl.displayName = 'ProLightListUl';
